import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';

const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = `${process.env.REACT_APP_ROOT}/api`;
const API_TAG = `https://okr.luvd.co.kr/util-manager/api`;
const handleErrors = err => {
    if (err && err.response && err.response.status === 401) {
        console.log(err);
    }

    return err;
};

const responseBody = res => res.body;

const requests = {
    del: url =>
        superagent
            .del(`${API_ROOT}${url}`)
            .end(handleErrors)
            .then(responseBody),
    get: url =>
        superagent
            .get(`${API_ROOT}${url}`)
            .end(handleErrors)
            .then(responseBody),
    put: (url, body) =>
        superagent
            .put(`${API_ROOT}${url}`, body)
            .end(handleErrors)
            .then(responseBody),
    post: (url, body) =>
        superagent
            .post(`${API_ROOT}${url}`, body)
            .end(handleErrors)
            .then(responseBody),
};

const requests2 = {
    del: url =>
        superagent
            .del(`${API_TAG}${url}`)
            .end(handleErrors)
            .then(responseBody),
    get: url =>
        superagent
            .get(`${API_TAG}${url}`)
            .end(handleErrors)
            .then(responseBody),
    put: (url, body) =>
        superagent
            .put(`${API_TAG}${url}`, body)
            .end(handleErrors)
            .then(responseBody),
    post: (url, body) =>
        superagent
            .post(`${API_TAG}${url}`, body)
            .end(handleErrors)
            .then(responseBody),
};

const Diagnosis = {
    getQuestionList: (category) =>
        requests.get(`/common/question/category/${category}`),
    createAnswer: (data) =>
        requests.post(`/diagnosis`, data),
};

const GTM = {
    getGtmTag: (type, url) =>
        requests2.get(`/external-code/type/${type}/url/${url}`),
}

export default {
    Diagnosis,
    GTM,
};
